// EDS Breakpoints: https://eventbrite.atlassian.net/wiki/spaces/FRONTEND/pages/15500640332/EDS+Breakpoints
export const SMALL_NARROW_WIDTH = 360;
export const SMALL_WIDTH = 480;
export const SMALL_WIDE_WIDTH = 660;
export const MEDIUM_NARROW_WIDTH = 792;
export const MEDIUM_WIDTH = 960;
export const MEDIUM_WIDE_WIDTH = 1080;
export const LARGE_NARROW_WIDTH = 1152;
export const LARGE_WIDTH = 1272;
export const LARGE_WIDE_WIDTH = 1608;
